import { createCurrentSelector } from '@beef/redux';
import { emptyArr, emptyObj } from '@beef/utils';
import { createSelector } from '@reduxjs/toolkit';
import { getTariffsGroup } from "../tariffs/selectors";
import { createMergedBlockSelector } from "../../selectors";
import { DEVICE_CARD_SIZE } from "../constants";
import { getDevicesBlock } from "../selectors";
export var getDevicesData = createMergedBlockSelector(getDevicesBlock);
var getDevices = function getDevices(state) {
  return getDevicesData(state).devices || emptyObj;
};
export var getCurrentDevices = createSelector([getDevices, getTariffsGroup], function (devices, group) {
  return devices[group] || emptyArr;
});
var _createCurrentSelecto = createCurrentSelector(getCurrentDevices, function (item) {
    return item.alias;
  }),
  CurrentDeviceProvider = _createCurrentSelecto.CurrentProvider,
  __ = _createCurrentSelecto.selectCurrent,
  withDeviceMapper = _createCurrentSelecto.withCurrentProviderMapper;
export { CurrentDeviceProvider, __, withDeviceMapper };
export var getDeviceBlockTitle = function getDeviceBlockTitle(state) {
  return getDevicesData(state).title;
};
export var getDeviceBlockColor = function getDeviceBlockColor(state) {
  return getDevicesData(state).colors || emptyObj;
};
export var getDeviceTexts = function getDeviceTexts(state) {
  return getDevicesData(state).texts || emptyObj;
};
export var getDeviderSignPriceUnit = function getDeviderSignPriceUnit(state) {
  return getDevicesData(state).deviderSignPriceUnit || emptyObj;
};
export var getDeviceImage = function getDeviceImage(state) {
  return __(state).imageUrl || '';
};
export var getDeviceTags = function getDeviceTags(state) {
  return __(state).tags || emptyArr;
};
export var getDeviceTitle = function getDeviceTitle(state) {
  return __(state).title || '';
};
export var getDeviceBenefits = function getDeviceBenefits(state) {
  return __(state).features || emptyArr;
};
export var getDevicePrice = function getDevicePrice(state) {
  return __(state).price || emptyObj;
};
export var getPaymentPeriodText = function getPaymentPeriodText(state) {
  var _;
  return (_ = __(state)) === null || _ === void 0 ? void 0 : _.paymentPeriodText;
};
export var getTariffsWithIncludedDevice = function getTariffsWithIncludedDevice(state) {
  return __(state).includedIn || emptyArr;
};
export var getDeviceSelection = function getDeviceSelection(state) {
  return __(state).selection || '';
};
export var getTariffUrl = function getTariffUrl(state) {
  return __(state).tariffUrl || '';
};
export var getDeviceAlias = function getDeviceAlias(state) {
  return __(state).alias;
};
export var getDeviceDescription = function getDeviceDescription(state) {
  return __(state).deviceDescription;
};
export var getDeviceType = function getDeviceType(state) {
  return __(state).type || '';
};
export var getDeviceDocumentation = function getDeviceDocumentation(state) {
  return __(state).documentation || emptyArr;
};
export var getConnectedUrl = createSelector([getTariffUrl, getDeviceAlias, getDeviceType], function (tariffUrl, alias, type) {
  return tariffUrl && "".concat(tariffUrl, "?enableService=add-service&type=").concat(type, "&alias=").concat(alias);
});
export var getDeviceCardSize = createSelector([getCurrentDevices], function () {
  var devices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (devices.length === 1) {
    return DEVICE_CARD_SIZE.large;
  }
  if (devices.length === 2) {
    return DEVICE_CARD_SIZE.medium;
  }
  if (devices.length > 2) {
    return DEVICE_CARD_SIZE.small;
  }
  return null;
});
export var getIncludedInTariffText = createSelector([getDeviceTexts, getTariffsWithIncludedDevice], function (texts, includedInTariffs) {
  return (includedInTariffs === null || includedInTariffs === void 0 ? void 0 : includedInTariffs.length) > 1 ? texts.includedInTariffs : texts.includedInOneTariff;
});
export var getDeviceColor = createSelector([getDeviceBlockColor, __], function (colors, device) {
  return colors[device.alias];
});
export var getCardOptions = createSelector([getDeviceCardSize], function (cardSize) {
  var options = {
    edgeIndent: 20,
    gutter: 16,
    hasCarousel: true,
    maxSize: 420,
    maxVisible: 1.4,
    minSize: 350,
    minVisible: 0.1
  };
  if (cardSize === DEVICE_CARD_SIZE.small) {
    options.maxSize = 410;
  }
  if (cardSize === DEVICE_CARD_SIZE.medium) {
    options.maxSize = 624;
  }
  if (cardSize === DEVICE_CARD_SIZE.large) {
    options.maxSize = 729;
  }
  return options;
});